import React from "react";
import { Paper, Typography } from "@mui/material";
import MuiAreaChart from "./MuiAreaChart.tsx";

const RevenueTrendChart = () => {
  const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun"];
  const revenue = [10000, 12000, 15000, 18000, 16000, 20000];

  return (
    <Paper elevation={2} sx={{ p: 2 }}>
      <Typography variant="h6" sx={{ mb: 1 }}>Revenue Trends</Typography>
      <MuiAreaChart xLabels={months} yData={revenue} label="Revenue ($)" />
    </Paper>
  );
};

export default RevenueTrendChart;
